import { api } from './client';

/**
 * Platform announcements: the live banner, and the admin console for them.
 *
 * Paths are inline here rather than in `endpoints.js` until they are merged
 * into it.
 */
const ADMIN = '/admin/announcements';

/** What the signed-in user's banner shows now (at most five, newest first). */
export function listLive() {
  return api.get('/announcements/live');
}

export function listAnnouncements(params) {
  return api.getPaginated(ADMIN, { params });
}

export function createAnnouncement(input) {
  return api.post(ADMIN, input);
}

export function updateAnnouncement(id, input) {
  return api.patch(`${ADMIN}/${id}`, input);
}

export function deleteAnnouncement(id) {
  return api.delete(`${ADMIN}/${id}`);
}

/** A notification to one person, from the platform. */
export function sendNotice(input) {
  return api.post(`${ADMIN}/notice`, input);
}
